import React from 'react';
import { GatsbyImage } from 'gatsby-plugin-image';
import styled, { css } from 'styled-components';
import {
  fontSize,
  sectionMargins,
  standardColours,
  minBreakpointQuery,
} from '../styles';
import { Container } from './ui';

const StyledQuote = styled.section`
  ${sectionMargins()};
`;

const StyledWrapper = styled.div`
  ${({ hasImage }) => {
    if (hasImage) {
      return css`
        ${minBreakpointQuery.small`
          display: grid;
          grid-template-columns: 1.5fr 2fr;
        `}
      `;
    }
  }}
`;

const StyledTextWrapper = styled.blockquote`
  background-color: ${standardColours.grey};
  text-align: center;
  padding: 80px 50px;
  margin: 0;

  ${minBreakpointQuery.small`
    display: flex;
    align-items: center;
    justify-content: center;
  `}

  ${minBreakpointQuery.medium`
    padding: 80px 75px;
  `}

  ${minBreakpointQuery.mlarge`
    padding: 80px 100px;
  `}
`;

const StyledText = styled.p`
  line-height: 1.8;

  ${({ hasImage }) => {
    if (hasImage) {
      return css`
        ${fontSize(20)};

        ${minBreakpointQuery.mlarge`
          ${fontSize(25)};
        `}
      `;
    } else {
      return css`
        ${fontSize(25)};

        ${minBreakpointQuery.mlarge`
          ${fontSize(30)};
        `}

        ${minBreakpointQuery.large`
          ${fontSize(35)};
        `}
      `;
    }
  }}
`;

const Quote = ({ text, image }) => (
  <StyledQuote>
    <Container>
      <StyledWrapper hasImage={image ? true : false}>
        {image && <GatsbyImage image={image.gatsbyImageData} alt={image.alt} />}
        <StyledTextWrapper>
          <StyledText hasImage={image ? true : false}>"{text}"</StyledText>
        </StyledTextWrapper>
      </StyledWrapper>
    </Container>
  </StyledQuote>
);

export default Quote;
